import React from 'react';
import { GetRewardedIcon, ActivityIcon, WatchRewardsIcon } from '../icons';

const FEATURES = [
    {
        icon: <ActivityIcon />,
        label: 'Complete everyday activities & earn cash automatically',
    },
    {
        icon: <GetRewardedIcon/>,
        label: 'Get rewarded across surveys, offers, and more',
    },
    {
        icon: <WatchRewardsIcon />,
        label: 'Watch your rewards grow with every activity you complete',
    },
];

const ExplanationGraphic = () =>
    <ul className="feature-list">
        {FEATURES.map((f) => (
            <li key={f.label} className="feature-item">
                <div className="feature-icon">{f.icon}</div>
                <span>{f.label}</span>
            </li>
        ))}
    </ul>
;

export default ExplanationGraphic;